import { SupportedChainId } from 'constants/chains'

export const START_BLOCKS: { [key: string]: number } = {
  [SupportedChainId.XDC]: 59506303,
  [SupportedChainId.XDC_TESTNET]: 48352140,
}
